import axios from "axios";
import GenericBody from "../Componentes/GenericBody";
import NavBar from "../Componentes/NavBar";
import Overlay from "../Componentes/Overlay";
import SmallLoading from "../Componentes/Utils/SmallLoading";
import FormComp from "../Componentes/FormComp";

import { useEffect, useState } from "react";
import { formatCPF } from "../Funcoes/FormatCPF";
import styled from "styled-components";

import { FaRegTrashAlt } from "react-icons/fa";
import { MdOutlineClose } from "react-icons/md";
import GenericForm from "../Componentes/Utils/GenericForm";

const TabelaDiv = styled.div`
        width: 100%;
        flex: 1;
        background-color: #F3F3F3;
        border-radius: 5px;
        overflow: auto;
        display: flex;
        flex-direction: column;
    `

const Tabela2Div = styled.div`
    width: 95%;
    max-height: 300px;
    background-color: #F3F3F3;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    color: black;
    margin: 0 auto 20px auto;
    overflow: auto;
`

const TabelaContainer = styled.table`
        width: 100%;
        border-collapse: collapse;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    `

const TabelaHeader = styled.thead`
        background-color: #FAFAFA;
        color: black;
        position: sticky;
        top: 0;
    `

const LineHeader = styled.tr`
        height: 40px;
        font-weight: bold;
        text-align: left;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    `

const CelHeader = styled.th`
        padding: 0 15px;
        box-sizing: border-box;
    `

const StatusDiv = styled.div`
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: ${props =>
        props.status === 1 ? 'green' : 'red'};
    `

const LineBody = styled.tr`
        height: 35px;
        text-align: left;
        border-bottom: 1px solid #ddd;
        background-color: ${props => props.isSelected ? '#29ff58' : 'transparent'};
        &:hover {
            background-color: ${props => props.isSelected ? '#29ff58' : '#e6e6e6'};
        }
        cursor: pointer;
    `

const CelBody = styled.td`
        padding: 0 15px;
        box-sizing: border-box;
    `

const StatusContainer = styled.div`
        display: flex;
        align-items: center;
        gap: 10px;
    `

const ButtonsContainer = styled.div`
    display: flex;
    gap: 10px;
    height: 45px;
    margin-left: auto;
    width: 100%;
`

const ButtonPermission = styled.button`
    height: 100%;
    border: none;
    background-color: #007BFF;
    color: white;
    border-radius: 10px;
    border: 2px solid white;
    padding: 0 10px;
    font-weight: bold;
    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
    cursor: pointer;
    &:hover {
        background-color: #0056b3;
    }
`

const ButtonObras = styled.button`
    height: 100%;
    border: none;
    background-color: #007BFF;
    color: white;
    border-radius: 10px;
    border: 2px solid white;
    padding: 0 10px;
    font-weight: bold;
    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
    cursor: pointer;
    &:hover {
        background-color: #0056b3;
    }
`
const ButtonDelete = styled.button`
        height: 100%;
        border: none;
        background-color: #dc3545;
        color: white;
        border-radius: 10px;
        border: 2px solid white;
        padding: 0 10px;
        font-weight: bold;
        font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
        cursor: pointer;
        &:hover {
            background-color: #c82333;
        }
`

const ModalContainer = styled.div`
    width: 550px;
    max-height: 90dvh;
    background-color: white;
    border-radius: 10px;
    margin: auto;
    overflow: auto;
    h3{
        color: black;
        text-align: center;
        font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
        text-decoration: underline;
        margin: 25px 0 15px 0;
        font-size: 16px;
    }
`

const DeleteModalContainer = styled.div`
    width: 450px;
    max-height: 90dvh;
    background-color: white;
    border-radius: 10px;
    margin: auto;
    border: 2px solid red;
    padding: 20px;
    box-sizing: border-box;
    h3{
        color: black;
        text-align: center;
        font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
        text-decoration: underline;
        margin: 25px 0 15px 0;
        font-size: 16px;
    }
    p{
        color: #000000ca;
        text-align: center;
        font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
        font-size: 15px;
    }
`

const ButtonsDeleteContainer = styled.div`
    display: flex;
    justify-content: center;
    gap: 10px;
    width: 100%;
    height: 45px;
    margin-top: 30px;
`

const ButtonDeleteConfirm = styled.button`
    height: 100%;
    border: none;
    background-color: #dc3545;
    color: white;
    border-radius: 10px;
    border: 2px solid white;
    flex: 1;
    font-weight: bold;
    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
    cursor: pointer;
    &:hover {
        background-color: #c82333;
    }
    transition: .3s;
`

const CancelButton = styled.button`
    height: 100%;
    border: none;
    background-color: #6c757d;
    color: white;
    border-radius: 10px;
    border: 2px solid white;
    flex: 1;
    font-weight: bold;
    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
    cursor: pointer;
    &:hover {
        background-color: #5a6268;
    }
    transition: .3s;
`

const ModalLoading = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000;
    backdrop-filter: blur(5px);
`

const ContainerPermissions = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px;
    gap: 10px;
    color: black;
    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
`

const HeaderPermissions = styled.div`
    display: flex;
    width: 100%;
    height: 45px;
    background-color: #263B4B;
    align-items: center;
    padding: 0 5px;
    box-sizing: border-box;
`

const PermissionItem = styled.label`
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-size: 14px;
    
    input{
        cursor: pointer;
    }
`

const FilterInput = styled.input`
    flex: 1;
    height: 100%;
    border: none;
    border-radius: 10px;
    padding: 0 10px;
    box-sizing: border-box;
    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
    outline: none;
    font-size: 16px;
`

const UserAccess = () => {

    const [users, setUsers] = useState([]);
    const [usersFilter, setUsersFilter] = useState([]);

    const [loading, setLoading] = useState(false);

    const getUsers = async () => {

        try {

            const { data } = await axios.get('https://sistemaintegrado.palmont.com.br/Painel/API/AccessManagement/GetUsers/');

            setUsers(data);
            setUsersFilter(data)

            console.log(data);

        } catch (e) {

            console.log(e);

        }

    }

    useEffect(() => {

        getUsers();

    }, [])

    const [selectedUser, setSelectedUser] = useState(null);

    const [permissonsModal, setPermissonsModal] = useState(false);
    const [obrasModal, setObrasModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);

    const [userPermissions, setUserPermissions] = useState([]);
    const [loadingPermissions, setLoadingPermissions] = useState(false);
    const [errorPermissions, setErrorPermissions] = useState(false);
    const [savingPermissions, setSavingPermissions] = useState(false)

    const [optionsObras, setOptionsObras] = useState([]);
    const [libObras, setLibObras] = useState([]);

    const [loadingObras, setLoadingObras] = useState(false);
    const [loadingDelete, setLoadingDelete] = useState(false);

    const openPermissionsModal = async () => {

        if (selectedUser) {

            setPermissonsModal(true);

            setLoadingPermissions(true);
            try {

                const { data } = await axios.post('https://sistemaintegrado.palmont.com.br/Painel/API/AccessManagement/GetUserPermissions/', {
                    userId: selectedUser
                },{
                    withCredentials: true
                });

                setUserPermissions(data);
                console.log(data);

            } catch (e) {

                console.error("Erro ao carregar permissões do usuário:", e);
                setErrorPermissions(true);

            } finally {

                setLoadingPermissions(false);

            }


        } else {

            alert("Selecione um usuário para editar as permissões.");

        }

    }

    const closePermissionsModal = () => {

        setPermissonsModal(false);
        setUserPermissions([]);
        setErrorPermissions(false);
        setLoadingPermissions(false);
        setSelectedUser(null);

    }

    const handlePermissionChange = async (permissionId) => {
        const previousPermissions = [...userPermissions];

        const updatedPermissions = userPermissions.map(item =>
            item.id === permissionId
                ? { ...item, has_permission: item.has_permission === 1 ? 0 : 1 }
                : item
        );

        setUserPermissions(updatedPermissions);

        try {

            setSavingPermissions(true)

            const { data } = await axios.post(
                'https://sistemaintegrado.palmont.com.br/Painel/API/AccessManagement/UpdateUserPermission/',
                {
                    userId: selectedUser,
                    permissionId,
                    hasPermission: updatedPermissions.find(item => item.id === permissionId).has_permission
                },
                {
                    withCredentials: true
                }
            );

            console.log(data);
        } catch (e) {
            setUserPermissions(previousPermissions);
            alert("Erro ao atualizar permissão. Tente novamente.");
        } finally {
            setSavingPermissions(false)
        }
    };

    const openObrasModal = async () => {

        if (selectedUser) {

            setObrasModal(true);
            setLoadingObras(true);

            try {

                const [obrasResponse, obrasLibResponse] = await Promise.all([
                    axios.get('https://sistemaintegrado.palmont.com.br/Painel/API/GetAllObras/'),
                    axios.post('https://sistemaintegrado.palmont.com.br/Painel/API/GetObrasLib/', {
                        id: selectedUser
                    })
                ])

                setOptionsObras(obrasResponse.data);
                setLibObras(obrasLibResponse.data);

            } catch (e) {

                console.error("Erro ao carregar obras:", e);
                alert("Erro ao carregar obras. Tente novamente.");

            } finally {

                setLoadingObras(false);

            }

        } else {

            alert("Selecione um usuário para selecionar obras.");

        }

    }

    const [selectedNewObra, setSelectedNewObra] = useState("");

    const getObrasLib = async () => {

        if (selectedUser) {

            setLoadingObras(true);

            try {

                const { data } = await axios.post('https://sistemaintegrado.palmont.com.br/Painel/API/GetObrasLib/', {
                    id: selectedUser
                });

                setLibObras(data);

            } catch (e) {

                console.error("Erro ao carregar obras liberadas:", e);
                alert("Erro ao carregar obras liberadas. Tente novamente.");

            } finally {

                setLoadingObras(false);

            }

        } else {

            alert("Selecione um usuário para carregar as obras liberadas.");

        }

    }

    const submitCC = async () => {

        if (!selectedNewObra) {

            alert("Selecione um centro de custo para liberar.");
            return;

        }

        setLoadingObras(true);

        try {

            await axios.post('https://sistemaintegrado.palmont.com.br/Painel/API/AccessManagement/UpdateUserCC/', {
                user: selectedUser,
                centro_custo: selectedNewObra
            },
                {
                    withCredentials: true
                })

            await getObrasLib();

        } catch (e) {

            console.log(e);

        } finally {

            setLoadingObras(false);

        }

    }

    const deleteCC = async (centro_custo) => {

        setLoadingObras(true);

        try {

            await axios.delete(`https://sistemaintegrado.palmont.com.br/Painel/API/AccessManagement/DeleteUserCC/index.php?user=${selectedUser}&centro_custo=${centro_custo}`,
                {
                    withCredentials: true
                });

            await getObrasLib();

        } catch (e) {

            console.log(e);
            alert("Erro ao excluir centro de custo. Tente novamente.");

        } finally {

            setLoadingObras(false);

        }

    }

    const openDeleteModal = () => {

        if (selectedUser) {

            setDeleteModal(true);

        } else {

            alert("Selecione um usuário para excluir.");

        }

    }

    const deleteUser = async () => {

        if (!selectedUser) {

            alert("Selecione um usuário para excluir.");
            return;

        }

        setLoadingDelete(true);

        try {

            await axios.delete(`https://sistemaintegrado.palmont.com.br/Painel/API/AccessManagement/DeleteUser/index.php?user=${selectedUser}`, {
                withCredentials: true
            });

            await getUsers();

            setDeleteModal(false);
            setSelectedUser(null);

        } catch (e) {

            console.error("Erro ao excluir usuário:", e);
            alert("Erro ao excluir usuário. Tente novamente.");

        } finally {

            setLoadingDelete(false);

        }

    }

    const [emailFilter, setEmailFilter] = useState("");

    const handleFilter = () => {

        if (emailFilter.trim() === "") {

            setUsersFilter(users);

        } else {

            const filteredUsers = users.filter(user =>
                user.email.toLowerCase().includes(emailFilter)
            );
            setUsersFilter(filteredUsers);

        }
    }

    useEffect(() => {

        handleFilter();

    }, [emailFilter, users]);

    return (
        <>
            <NavBar title="GERENCIADOR DE PERMISSÕES" />
            <GenericBody>
                <ButtonsContainer>
                    <FilterInput
                        type="text"
                        placeholder="E-MAIL..."
                        value={emailFilter}
                        onChange={e => setEmailFilter((e.target.value).toLowerCase())}
                    />
                    <ButtonPermission onClick={openPermissionsModal} >EDITAR PERMISSÕES</ButtonPermission>
                    <ButtonObras onClick={openObrasModal} >SELECIONAR OBRAS</ButtonObras>
                    <ButtonDelete onClick={openDeleteModal} >EXCLUIR USUÁRIO</ButtonDelete>
                </ButtonsContainer>
                <TabelaDiv>
                    <TabelaContainer>
                        <TabelaHeader>
                            <LineHeader>
                                <CelHeader>USUÁRIO</CelHeader>
                                <CelHeader>EMAIL</CelHeader>
                                <CelHeader>CPF</CelHeader>
                            </LineHeader>
                        </TabelaHeader>
                        <tbody>
                            {
                                usersFilter.map(item => (
                                    <LineBody
                                        key={item.id}
                                        onClick={() => setSelectedUser(selectedUser === item.id ? null : item.id)}
                                        isSelected={selectedUser === item.id}
                                    >
                                        <CelBody>
                                            <StatusContainer>
                                                <StatusDiv status={item.ativo} />
                                                {item.nome}
                                            </StatusContainer>
                                        </CelBody>
                                        <CelBody>{item.email}</CelBody>
                                        <CelBody>{formatCPF(item.cpf)}</CelBody>
                                    </LineBody>
                                ))
                            }
                        </tbody>
                    </TabelaContainer>
                </TabelaDiv>
            </GenericBody>
            <Overlay state={permissonsModal} >
                <ModalContainer>

                    <HeaderPermissions>
                        <MdOutlineClose size={30} fill="red" onClick={closePermissionsModal} />
                    </HeaderPermissions>

                    {
                        loadingPermissions ? (
                            <SmallLoading />
                        ) : errorPermissions ? (
                            <h3>ERRO</h3>
                        ) : (

                            <ContainerPermissions>

                                {

                                    savingPermissions && (

                                        <ModalLoading>
                                            <SmallLoading />
                                        </ModalLoading>

                                    )

                                }

                                {
                                    userPermissions.map(item => (
                                        <PermissionItem key={item.id} >
                                            <input type="checkbox" defaultChecked={item.has_permission === 1} onChange={() => handlePermissionChange(item.id)} />
                                            {item.descricao}
                                        </PermissionItem>
                                    ))
                                }
                            </ContainerPermissions>

                        )
                    }

                </ModalContainer>
            </Overlay>
            <Overlay state={obrasModal} >
                <ModalContainer>
                    <HeaderPermissions>
                        <MdOutlineClose size={30} fill="red" onClick={() => setObrasModal(false)} />
                    </HeaderPermissions>

                    {
                        loadingObras ? (
                            <SmallLoading />
                        ) : (
                            <>
                                <h3>Liberar Centro de Custo</h3>
                                <GenericForm tamanho="95" onSubmit={submitCC} >
                                    <FormComp
                                        title="CENTRO DE CUSTO"
                                        type="select"
                                        options={optionsObras.map(item => (item.OBRA))}
                                        valor={selectedNewObra}
                                        changeFunc={(e) => setSelectedNewObra(e.target.value)}
                                    />
                                </GenericForm>

                                <h3>Centro de Custos Liberados</h3>

                                <Tabela2Div>
                                    <TabelaContainer>
                                        <TabelaHeader>
                                            <LineHeader>
                                                <CelHeader>CENTRO DE CUSTO</CelHeader>
                                                <CelHeader></CelHeader>
                                            </LineHeader>
                                        </TabelaHeader>
                                        <tbody>
                                            {libObras.length === 0 ? (
                                                <tr>
                                                    <td colSpan={2} style={{ textAlign: 'center', padding: '10px' }}>
                                                        Nenhum registro encontrado.
                                                    </td>
                                                </tr>
                                            ) : (
                                                libObras.map(item => (
                                                    <LineBody key={item.id}>
                                                        <CelBody>{item.centro_custo}</CelBody>
                                                        <CelBody>
                                                            <FaRegTrashAlt size={20} fill="red" onClick={() => deleteCC(item.centro_custo)} />
                                                        </CelBody>
                                                    </LineBody>
                                                ))
                                            )}
                                        </tbody>
                                    </TabelaContainer>
                                </Tabela2Div>
                            </>
                        )
                    }
                </ModalContainer>
            </Overlay>
            <Overlay state={deleteModal} >
                <DeleteModalContainer>
                    {
                        loadingDelete ? (
                            <SmallLoading />
                        ) : (
                            <>
                                <h3>EXCLUIR USUÁRIO</h3>
                                <p>Tem certeza que deseja excluir este usuário?</p>
                                <ButtonsDeleteContainer>
                                    <CancelButton onClick={() => setDeleteModal(false)}>CANCELAR</CancelButton>
                                    <ButtonDeleteConfirm onClick={deleteUser}>EXCLUIR</ButtonDeleteConfirm>
                                </ButtonsDeleteContainer>
                            </>
                        )
                    }
                </DeleteModalContainer>
            </Overlay>
        </>
    )
}

export default UserAccess;